import React from "react";
import "./Footer.css";
import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";
import { useLocalContext } from "../../context/LocalContext";

const Footer = () => {
  const { webinfo = {} } = useLocalContext();
  const navigate = useNavigate();

  const year = new Date().getFullYear();
  const address = webinfo?.address || "2100 Ross Avenue, Suite 2700, Dallas, TX 75201";
  const email = webinfo?.email || "contact@smartprintersolutions.com";
  const phoneText = webinfo?.phone || webinfo?.phonecall || "Contact page";
  const phoneCall = webinfo?.phonecall || webinfo?.phone || "";
  const brand = webinfo?.name || "smartprintersolutions.com";

  return (
    <footer className="ftr" aria-label="Site footer">
      <div className="ftr__wrap">
        <motion.div
          className="ftr__cta"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.4 }}
          transition={{ duration: 0.65 }}
        >
          <div>
            <h2 className="ftr__ctaTitle">Ready to discuss your marketing plan?</h2>
            <p className="ftr__ctaText">
              Share your goals, budget range, and what you have tried. We respond with realistic next steps—not a
              one-size-fits-all pitch. No guaranteed ROI or rankings.
            </p>
          </div>
          <div className="ftr__ctaBtns">
            <button type="button" className="ftr__btn ftr__btn--primary" onClick={() => navigate("/contact")}>
              Contact us <span aria-hidden="true">→</span>
            </button>
            <button type="button" className="ftr__btn ftr__btn--ghost" onClick={() => navigate("/services")}>
              Browse services
            </button>
          </div>
        </motion.div>

        <div className="ftr__grid">
          <div>
            <p className="ftr__brandName">{brand}</p>
            <p className="ftr__brandText">
              Dallas digital marketing studio offering SEO, paid media, content, email, and analytics—with clear
              contracts and honest limitations.
            </p>
            <address className="ftr__meta">
              <p>
                <span className="ftr__metaLabel">Location</span>
                {address}
              </p>
              <p>
                <span className="ftr__metaLabel">Email</span>
                <a href={`mailto:${email}`}>{email}</a>
              </p>
              <p>
                <span className="ftr__metaLabel">Phone</span>
                {phoneCall ? <a href={`tel:${phoneCall}`}>{phoneText}</a> : <span>{phoneText}</span>}
              </p>
            </address>
          </div>

          <div>
            <h3 className="ftr__h4">Services</h3>
            <ul className="ftr__links">
              <li>
                <button type="button" onClick={() => navigate("/services")}>
                  All services
                </button>
              </li>
              <li>
                <button type="button" onClick={() => navigate("/services/digital-strategy")}>
                  Strategy &amp; consulting
                </button>
              </li>
              <li>
                <button type="button" onClick={() => navigate("/services/seo-content")}>
                  SEO &amp; content
                </button>
              </li>
              <li>
                <button type="button" onClick={() => navigate("/services/paid-media")}>
                  Paid media
                </button>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="ftr__h4">Company</h3>
            <ul className="ftr__links">
              <li>
                <button type="button" onClick={() => navigate("/about")}>
                  About
                </button>
              </li>
              <li>
                <button type="button" onClick={() => navigate("/process")}>
                  Our process
                </button>
              </li>
              <li>
                <button type="button" onClick={() => navigate("/contact")}>
                  Contact
                </button>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="ftr__h4">Legal</h3>
            <ul className="ftr__links">
              <li>
                <button type="button" onClick={() => navigate("/Terms-and-condition")}>
                  Terms
                </button>
              </li>
              <li>
                <button type="button" onClick={() => navigate("/privacy-policy")}>
                  Privacy
                </button>
              </li>
              <li>
                <button type="button" onClick={() => navigate("/disclaimer")}>
                  Disclaimer
                </button>
              </li>
            </ul>
          </div>
        </div>

        <div className="ftr__bottom">
          <p className="ftr__copy">
            © {year} {brand}. Marketing results vary; see disclaimer.
          </p>
          <div className="ftr__miniLinks">
            <button type="button" onClick={() => navigate("/privacy-policy")}>
              Privacy
            </button>
            <button type="button" onClick={() => navigate("/Terms-and-condition")}>
              Terms
            </button>
            <button type="button" onClick={() => navigate("/contact")}>
              Contact
            </button>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
